import angular from 'angular';
import imageCircle from './imageCircle';

export default angular
  .module('components.imageCircle', [])
  .component('imageCircle', imageCircle).name;
